import { Typography } from "@mui/material";
import packageFile from "../../../package.json";

function ShowLastUpdate() {
  return (
    <Typography
      variant="caption"
      textAlign={"end"}
      // sx={{
      //   position: "fixed",
      //   right: 20,
      //   bottom: 4,
      //   zIndex: 10,
      // }}
    >
      Last Updated :- {packageFile.lastUpdated}
    </Typography>
  );
}

export default ShowLastUpdate;
